import React from "react";
import FilterModal from "../../components/FilterModal";
import Modal from "../../components/Modal";
import PageActions from "../../components/PageActions";
import PageHeader from "../../components/PageHeader";
import Table from "../../components/Table";
import Pagination from "../../components/Pagination";
import { createTableActions } from "../../utils/tableActions";
import BordasForm from "./components/BordasForm";
import { BordasProvider, useBordas } from "./context/BordasContext";

const BordasContent: React.FC = () => {
  const {
    bordas,
    isLoading,
    isModalOpen,
    isFilterModalOpen,
    formState,
    filterFields,
    tableData,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    activeFiltersCount,
    isSaving,
    openFilterModal,
    closeFilterModal,
    openCreateModal,
    openEditModal,
    closeModal,
    handleDelete,
    handleSubmit,
    handleFilterFieldChange,
    handleSearch,
    handleClear,
    setFormNome,
    setCurrentPage,
  } = useBordas();

  const tableActions = createTableActions(
    (rowIndex) => {
      const selectedBorda = bordas[rowIndex];
      if (!selectedBorda) return;
      openEditModal(selectedBorda);
    },
    (rowIndex) => {
      const selectedBorda = bordas[rowIndex];
      if (!selectedBorda) return;
      handleDelete(selectedBorda);
    }
  );

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-4 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Gerenciar Bordas"
          description="Aqui você pode administrar as bordas do sistema."
        />
        <PageActions
          onFilter={openFilterModal}
          onAdd={openCreateModal}
          addButtonText="Nova Borda"
          activeFiltersCount={activeFiltersCount}
        />
      </div>

      <hr />

      <div className="overflow-x-auto pb-4">
        <div className="min-w-max">
          <Table headers={["Nome"]} data={tableData} actions={tableActions} />
        </div>
      </div>

      {totalPages > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
        />
      )}

      {isLoading && (
        <div className="mt-3 text-sm text-neutral-500">
          Carregando bordas...
        </div>
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={closeFilterModal}
        fields={filterFields}
        onFieldChange={handleFilterFieldChange}
        onSearch={handleSearch}
        onClear={handleClear}
      />

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={formState.id ? "Editar Borda" : "Nova Borda"}
      >
        {isModalOpen && (
          <BordasForm
            nome={formState.nome}
            isSaving={isSaving}
            onSubmit={handleSubmit}
            onCancel={closeModal}
            onNomeChange={setFormNome}
          />
        )}
      </Modal>
    </main>
  );
};

const Bordas: React.FC = () => {
  return (
    <BordasProvider>
      <BordasContent />
    </BordasProvider>
  );
};

export default Bordas;
